import { render, staticRenderFns } from "./family-group.vue?vue&type=template&id=186113f4&"
import script from "./family-group.vue?vue&type=script&lang=js&"
export * from "./family-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186113f4')) {
      api.createRecord('186113f4', component.options)
    } else {
      api.reload('186113f4', component.options)
    }
    module.hot.accept("./family-group.vue?vue&type=template&id=186113f4&", function () {
      api.rerender('186113f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/family-group.vue"
export default component.exports